<div aria-label="Signing in" class="loading-container" role="status">
    <div class="loading-content">
        <div class="loading-mark">
            <img alt="CyberRangeᶜᶻ Platform" class="loading-logo" src="./assets/logo/logo-black.svg" />
            <div class="loader" data-label="Signing in..."></div>
        </div>
    </div>
    <div class="layout-overlay signin-overlay">
        <div class="sidebar"></div>
        <div class="toolbar-bottom"></div>
        <div class="toolbar-top"></div>
        <img alt="" class="loading-sidebar-logo" src="./assets/logo/logo-black.svg" />
        @if (version()) {
            <span class="signin-version">{{ version() }}</span>
        }
        <svg aria-hidden="true" class="loading-notifications" viewBox="0 0 24 24">
            <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
        </svg>
    </div>
</div>
